import { isLocal } from '../localId/localId';
import {
  ADD_LOCAL_EQUIPMENT_CATEGORY,
  API_CREATE_EQUIPMENT_CATEGORY,
  API_LOAD_EQUIPMENT_CATEGORIES,
  API_REMOVE_EQUIPMENT_CATEGORY,
  API_UPDATE_EQUIPMENT_CATEGORY,
  REMOVE_LOCAL_EQUIPMENT_CATEGORY,
} from './equipmentCategory.reducer';

export const load = () => ({ resourceAction: API_LOAD_EQUIPMENT_CATEGORIES });
export const save = resource => ((isLocal(resource.id)) ? {
  resourceAction: API_CREATE_EQUIPMENT_CATEGORY,
  resource,
} : { resourceAction: API_UPDATE_EQUIPMENT_CATEGORY, resource });
export const add = () => ({ type: ADD_LOCAL_EQUIPMENT_CATEGORY });
export const remove = id => ((isLocal(id)) ? {
  type: REMOVE_LOCAL_EQUIPMENT_CATEGORY,
  id,
} : { resourceAction: API_REMOVE_EQUIPMENT_CATEGORY, id });



// WEBPACK FOOTER //
// ./src/reducers/equipmentCategory/equipmentCategory.actions.js